import React from 'react'
import { connect, ConnectedProps } from 'react-redux'

import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import { addRegionToPath } from 'lib/url/searchUrlUtils'

interface Props {
  to: string
}

function Redirect(props: Props & ConnectedProps<typeof connector>) {
  return (
    <RedirectWithStatus
      code={302}
      to={addRegionToPath(props.to, props.regionCode)}
    />
  )
}

function mapStateToProps(state: App.State) {
  return {
    regionCode: state.geo.currentRegionCode,
  }
}

const connector = connect(mapStateToProps)

export default connector(Redirect)
